import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assertAndContinue} from 'Asserts';
import BioentitySearchInput from 'inventory/BioentitySearchInput';
import FormGroup from 'ui-library/bs/FormGroup';
import {ChipSize} from 'ui-library/chips/Chip';
import FieldError from 'ui-library/FieldError';
import {Size} from 'ui-library/inputs/InputConstants';
import MultiValueTextInput from 'ui-library/inputs/MultiValueTextInput';

import {AvailableColumn, AvailableColumnType, ColumnFilter} from './SQLTemplateFormTypes';

export interface SQLFilterValueInputProps {
  columnFilter: ColumnFilter;
  filteredColumn: AvailableColumn;
  updateValues: (values: Array<string>, rawValues: string) => void;
}

export default function SQLFilterValueInput(props: SQLFilterValueInputProps): JSX.Element {
  const {typeInfo} = props.filteredColumn;
  let inputComponent;
  switch (typeInfo.type) {
    case AvailableColumnType.BIOENTITY:
      inputComponent = (
        <BioentitySearchInput
          chipSize={ChipSize.MINI}
          onChange={(bioentities) => {
            const ids = bioentities.map(({id}) => id).filter((id): id is string => id != null);
            props.updateValues(ids, ids.join(','));
          }}
          shouldAllowMultiple={true}
          selectedItems={props.columnFilter.values.map((id) => ({id}))}
          tagSchemaOrInterfaceId={typeInfo.linkedSchema ? typeInfo.linkedSchema.id : null}
        />
      );
      break;
    default:
      assertAndContinue(typeInfo.type === AvailableColumnType.TEXT, `Unexpected value type: ${typeInfo}`);

      inputComponent = (
        <MultiValueTextInput
          className={css(styles.textInput)}
          hasError={props.columnFilter.validationError != null}
          onChange={props.updateValues}
          value={props.columnFilter.rawValues}
          size={Size.MEDIUM}
        />
      );
  }

  return (
    <FormGroup>
      {inputComponent}
      <FieldError message={props.columnFilter.validationError} />
    </FormGroup>
  );
}

const styles = StyleSheet.create({
  textInput: {
    flexGrow: 1,
    flexBasis: 200,
    // Hardcode text input height because height from Size.MEDIUM is not set properly
    height: 36,
    maxWidth: 600,
  },
});
